<template>
  <div class="page_">
    <div class="pageTitle">
      让我们为您找到适合的出版方
    </div>
    <div class="pageTitle2">
      选择所有符合条件的
    </div>
    <div class="numberIcon">
      <div class="icons">
        <img src="../../assets/images/staticPage/intelligentContribute/f6-1.png" alt="">
        学术期刊
      </div>
      <div class="icons">
        <img src="../../assets/images/staticPage/intelligentContribute/f6-2.png" alt="">
        教育期刊
      </div>
      <div class="icons">
        <img src="../../assets/images/staticPage/intelligentContribute/f6-3.png" alt="">
        文学刊物
      </div>
      <div class="icons">
        <img src="../../assets/images/staticPage/intelligentContribute/f6-top.png" alt="" class="top_">
        <img src="../../assets/images/staticPage/intelligentContribute/f6-4.png" alt="">
        微信公众号
      </div>
      <div class="icons">
        <img src="../../assets/images/staticPage/intelligentContribute/f6-top.png" alt="" class="top_">
        <img src="../../assets/images/staticPage/intelligentContribute/f6-5.png" alt="">
        头条号
      </div>
      <div class="icons">
        <img src="../../assets/images/staticPage/intelligentContribute/f6-top.png" alt="" class="top_">
        <img src="../../assets/images/staticPage/intelligentContribute/f6-6.png" alt="">
        百家号
      </div>
    </div>
    <div class="f11-title">
      龙源与3000家刊社合作，完成确权登记后，可以免费将稿件投放到所有刊物
    </div>
    <div class="f11-container">
      <img src="../../assets/images/staticPage/intelligentContribute/f11-1.png" alt="">
      <img src="../../assets/images/staticPage/intelligentContribute/f11-2.png" alt="">
      <img src="../../assets/images/staticPage/intelligentContribute/f11-3.png" alt="">
      <img src="../../assets/images/staticPage/intelligentContribute/f11-4.png" alt="">
      <img src="../../assets/images/staticPage/intelligentContribute/f11-5.png" alt="">
      <img src="../../assets/images/staticPage/intelligentContribute/f11-6.png" alt="">
      <img src="../../assets/images/staticPage/intelligentContribute/f11-7.png" alt="">
      <img src="../../assets/images/staticPage/intelligentContribute/f11-8.png" alt="">
      <img src="../../assets/images/staticPage/intelligentContribute/f11-9.png" alt="">
      <img src="../../assets/images/staticPage/intelligentContribute/f11-10.png" alt="">
      <img src="../../assets/images/staticPage/intelligentContribute/f11-11.png" alt="">
      <div style="width:142px;"></div>
    </div>
    <div class="navTitle">
      <div>整合3000传统纸媒和免费高质量新媒体，打造值得付费的全新移动内容服务</div>
      <div>来自财讯集团、第一财经、康泰纳仕、法国桦榭等出版商覆盖各垂类的完整线下出版内容</div>
    </div>
    <div class="txtImg">
      <div class="item" v-for="item in pageData.navlist" :key="item">
        <div class="title_">
          {{ item.name }}
        </div>
        <div class="content_" v-for="items in item.list" :key="items">
          <div class="txt_" v-if="item.type == 2">
            {{ items.item }}
          </div>
          <div class="img_" v-if="item.type == 1">
            <img :src="items.item" alt="">
          </div>
        </div>
      </div>
    </div>

    <div class="tabs">
      <div v-for="item in pageData.tabs" :key="item" :class="item.type == pageData.tabsType ? 'active' : ''"
        @click="tabClick(item.type)">{{ item.name }}</div>
    </div>

    <div class="tabsContainer" v-if="pageData.tabsType == 1">
      <div class="left_">
        <div class="left-top">
          <div class="left-top-left">
            <div class="title_">
              <div>指定大众刊社投稿</div>
              <div>了解相关更多信息</div>
            </div>
            <div class="content_">
              <img src="../../assets/images/staticPage/intelligentContribute/manimg-1-logo.png" alt="">
              <div class="data">
                <div>
                  丛娴
                </div>
                <div>
                  从事版权工作9年
                </div>
              </div>
            </div>
          </div>
          <div class="man">
            <img src="../../assets/images/staticPage/intelligentContribute/manimg-1.png" alt="">
          </div>
        </div>
        <div class="left-bottom">
          比较这些产品 >
        </div>
      </div>
      <div class="right_">
        <div class="item">
          <div class="itemTitle">
            基础版
          </div>
          <div class="blueTxt">
            一键投稿给上百家刊社
          </div>
          <div class="price">
            ￥79
          </div>
          <div class="button">
            现在开始
          </div>
          <div class="scoreList">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star2.png" alt="">
          </div>
        </div>
        <div class="item">
          <div class="itemTitle">
            豪华版
          </div>
          <div class="blueTxt">
            15天内获得刊社反馈
          </div>
          <div class="price">
            ￥198
          </div>
          <div class="button">
            现在开始
          </div>
          <div class="scoreList">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
          </div>
        </div>
      </div>
    </div>

    <div class="tabsContainer" v-else>
      <div class="left_">
        <div class="left-top">
          <div class="left-top-left">
            <div class="title_">
              <div>指定学术投稿服务</div>
              <div>了解相关更多信息</div>
            </div>
            <div class="content_">
              <img src="../../assets/images/staticPage/intelligentContribute/manimg-2-logo.png" alt="">
              <div class="data">
                <div>
                  符宏
                </div>
                <div style="color:#CC3F1F;">
                  从事版权工作23年
                </div>
              </div>
            </div>
          </div>
          <div class="man">
            <img src="../../assets/images/staticPage/intelligentContribute/manimg-2.png" alt="">
          </div>
        </div>
        <div class="left-bottom">
          比较这些产品 >
        </div>
      </div>
      <div class="right_">
        <div class="item">
          <div class="itemTitle">
            基础版
          </div>
          <div class="blueTxt" style="color:#303133;">
            一键投稿给上百家刊社
          </div>
          <div class="price" style="color:#CC3F1F;">
            ￥79
          </div>
          <div class="button" style="background:#CC3F1F;">
            全面服务
          </div>
          <div class="scoreList">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star2.png" alt="">
          </div>
        </div>
        <div class="item">
          <div class="itemTitle">
            豪华版
          </div>
          <div class="blueTxt" style="color:#303133;">
            出版咨询专家帮助您优化稿件加大出版可能
          </div>
          <div class="price" style="color:#CC3F1F;">
            ￥198
          </div>
          <div class="button" style="background:#CC3F1F;">
            全面服务
          </div>
          <div class="scoreList">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <marketingPageFooter></marketingPageFooter>
  </div>
</template>

<script>
import { reactive } from "vue";
import marketingPageFooter from '@/components/marketingPageFooter.vue'
// import { useRoute, useRouter } from "vue-router";
// import { useStore } from "vuex";
// import Cookies from "js-cookie";

export default {
  name: "intelligentContribute",
  components: {
    marketingPageFooter
  },
  setup(prop) {
    console.log(prop);
    // const route = useRoute();
    // const router = useRouter();
    // const store = useStore();
    let pageData = reactive({
      navlist: [
        {
          name: '独家合作',
          type: 1,
          list: [
            {
              item: require('../../assets/images/staticPage/intelligentContribute/f3-1.png')
            },
            {
              item: require('../../assets/images/staticPage/intelligentContribute/f3-2.png')
            },
            {
              item: require('../../assets/images/staticPage/intelligentContribute/f3-3.png')
            }
          ]
        },
        {
          name: '时政社会',
          type: 2,
          list: [
            {
              item: '中国新闻周刊'
            },
            {
              item: '南风窗'
            },
            {
              item: '环球人物'
            },
            {
              item: '旗帜'
            },
            {
              item: '党建'
            },
            {
              item: '新民周刊'
            },
            {
              item: '南方人物周刊'
            },
            {
              item: '看天下'
            },
            {
              item: '南都周刊'
            }
          ]
        },
        {
          name: '商业财经',
          type: 2,
          list: [
            {
              item: '财经'
            },
            {
              item: '第一财经周刊'
            },
            {
              item: '商学院'
            },
            {
              item: '快公司'
            },
            {
              item: '中欧商业评论'
            },
            {
              item: '21世纪商业评论'
            },
            {
              item: '中国经济周刊'
            },
            {
              item: '财经国家周刊'
            },
            {
              item: '证券市场周刊'
            },
            {
              item: '创业邦'
            }
          ]
        },
        {
          name: '文化',
          type: 2,
          list: [
            {
              item: '读书'
            },
            {
              item: '书城'
            },
            {
              item: '文化纵横'
            },
            {
              item: '天涯'
            },
            {
              item: '书屋'
            },
            {
              item: '文史博览'
            },
            {
              item: '世界文化'
            },
            {
              item: '看历史'
            },
            {
              item: '读书文摘'
            },
            {
              item: '月读'
            }
          ]
        },
        {
          name: '科学与世界',
          type: 2,
          list: [
            {
              item: '看世界'
            },
            {
              item: '海外文摘'
            },
            {
              item: '世界博览'
            },
            {
              item: '世界知识'
            },
            {
              item: '环球人文地理'
            },
            {
              item: '西藏人文地理'
            },
            {
              item: '知识就是力量'
            },
            {
              item: '科学24小时'
            }
          ]
        },
        {
          name: '文学小说',
          type: 2,
          list: [
            {
              item: '科幻世界'
            },
            {
              item: '当代'
            },
            {
              item: '十月'
            },
            {
              item: '长江文艺'
            },
            {
              item: '译林'
            },
            {
              item: '北京文学'
            },
            {
              item: '读者'
            },
            {
              item: '故事会'
            },
            {
              item: '上海文学'
            },
            {
              item: '台港文学选刊'
            }
          ]
        },
        {
          name: '时尚娱乐',
          type: 2,
          list: [
            {
              item: 'GQ'
            },
            {
              item: 'ELLE'
            },
            {
              item: '睿仕'
            },
            {
              item: 'VOGUE'
            },
            {
              item: '家居廊'
            },
            {
              item: '安邸AD'
            },
            {
              item: '北京青年周刊'
            },
            {
              item: '电子竞技'
            },
            {
              item: '摄影之友'
            },
            {
              item: '凤凰生活'
            }
          ]
        },
        {
          name: '军事',
          type: 2,
          list: [
            {
              item: '轻兵器'
            },
            {
              item: '军事文摘'
            },
            {
              item: '现代兵器'
            },
            {
              item: '航空知识'
            },
            {
              item: '兵器知识'
            },
          ]
        },
        {
          name: '体育与运动',
          type: 2,
          list: [
            {
              item: '新体育'
            },
            {
              item: '户外探险'
            },
            {
              item: '第五频道'
            },
            {
              item: '扣篮'
            },
            {
              item: '羽毛球'
            },
          ]
        },
        {
          name: '汽车',
          type: 2,
          list: [
            {
              item: '名车志'
            },
            {
              item: '汽车杂志'
            },
            {
              item: '汽车与运动'
            },
            {
              item: '汽车之友'
            },
            {
              item: '世界汽车'
            },
          ]
        },
        {
          name: '旅行',
          type: 2,
          list: [
            {
              item: '中国国家旅游'
            },
            {
              item: '悦游Traveler'
            },
            {
              item: '旅游世界'
            },
            {
              item: '旅游'
            },
            {
              item: '旅游纵览'
            }
          ]
        },
        {
          name: '家庭生活',
          type: 2,
          list: [
            {
              item: '知音'
            },
            {
              item: '女友'
            },
            {
              item: '恋爱婚姻家庭'
            },
            {
              item: '家庭百事通'
            },
            {
              item: 'FAMILY家人'
            }
          ]
        },
        {
          name: '健康',
          type: 2,
          list: [
            {
              item: '大众健康'
            },
            {
              item: '食品与健康'
            },
            {
              item: '家庭医学'
            },
            {
              item: '心理与健康'
            },
            {
              item: '大众医学'
            }
          ]
        },
        {
          name: '亲子阅读',
          type: 2,
          list: [
            {
              item: '意林'
            },
            {
              item: '奥秘'
            },
            {
              item: '奇妙博物馆'
            },
            {
              item: '大自然探索'
            },
            {
              item: '知识窗'
            }
          ]
        }
      ],
      tabsType: 1,
      tabs: [
        {
          type: 1,
          name: '指定刊社投稿'
        },
        {
          type: 2,
          name: '指定刊社投稿'
        },
      ]
    })

    function tabClick(type) {
      pageData.tabsType = type
    }
    return {
      pageData,
      tabClick
    };
  },
};
</script>
<style lang='scss' scoped>
.page_ {
  display: flex;
  flex-direction: column;
  align-items: center;

  .tabsContainer {
    width: 700px;
    // height: 206px;
    border: 1px solid #E4E7ED;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    margin-bottom: 67px;
    font-weight: 700;
    .right_ {
      width: 332px;
      // padding: 19px 30px;
      // box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;

      .item:last-child {
        margin: 0;
      }

      .item {
        width: 120px;
        margin-right: 32px;

        .price {
          font-size: 18px;
          font-family: AlibabaPuHuiTiM;
          color: #008AEA;
          font-weight: 700;
        }

        .scoreList {
          display: flex;
          align-items: center;

          img {
            width: 24px;
          }
        }

        .button {
          width: 100%;
          height: 40px;
          font-size: 14px;
          font-family: AlibabaPuHuiTiM;
          color: #FFFFFF;
          line-height: 40px;
          text-align: center;
          margin: 8px 0;
          background: #008AEA;
          border-radius: 8px;
        }

        .blueTxt {
          height: 32px;
          // line-height: 32px;
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #008AEA;
          margin: 8px 0 24px;
        }

        .itemTitle {
          font-size: 14px;
          font-family: AlibabaPuHuiTiM;
          color: #303133;
          padding-bottom: 8px;
          box-sizing: border-box;
          border-bottom: 2px #e4e7ed solid;
          font-weight: 700;
        }
      }
    }

    .left_ {
      width: 370px;
      height: 100%;
      border-right: 1px solid #E4E7ED;

      .left-bottom {
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #008AEA;
        font-weight: 700;
        padding: 16px 30px;
        box-sizing: border-box;
      }

      .left-top {
        padding: 30px 30px 0 30px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        border-bottom: 1px solid #E4E7ED;


        .man {
          width: 110px;
          font-size: 0;

          img {
            width: 100%;
          }
        }

        .left-top-left {
          margin-bottom: 8px;
          .title_ {
            font-size: 18px;
            font-family: AlibabaPuHuiTiM;
            color: #303133;

            div:last-of-type {
              font-size: 14px;
              font-family: AlibabaPuHuiTiR;
              color: #008AEA;
              margin: 8px 0;
            }
          }

          .content_ {
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 60px;
              margin-right: 8px;

            }

            .data {
              font-size: 14px;
              font-family: AlibabaPuHuiTiM;
              color: #303133;
              margin-bottom: 4px;

              div:last-of-type {
                font-size: 12px;
                font-family: AlibabaPuHuiTiM;
                color: #008AEA;
              }
            }
          }
        }
      }
    }
  }

  .tabs {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    // background: #FFFFFF;
    box-shadow: 0px -12px 12px rgba(0, 0, 0, 0.1) inset;
    margin: 33px 0 32px;

    div {
      width: 400px;
      height: 78px;
      background: #E4E7ED;
      font-size: 18px;
      font-family: AlibabaPuHuiTiM;
      color: #303133;
      line-height: 78px;
      text-align: center;
      cursor: pointer;
      font-weight: 800;
    }

    .active {
      background: #fff;
      box-shadow: inset 0px 8px 0px 0px #008AEA;
    }
  }

  .txtImg {
    width: 910px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;

    .item {
      width: 114px;
      margin-bottom: 40px;

      .title_ {
        font-size: 18px;
        font-family: AlibabaPuHuiTiM;
        color: #303133;
        line-height: 24px;
        margin-bottom: 8px;
        font-weight: 800;
      }

      .content_ {
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #606266;
        font-weight: 700;

        .txt_ {
          margin-bottom: 5px;
        }

        .img_ {
          height: 40px;
          margin-bottom: 10px;

          img {
            height: 100%;
          }
        }
      }
    }
  }

  .navTitle {
    text-align: center;
    font-weight: 700;
    margin: 69px 0 24px;

    div:nth-of-type(1) {
      font-size: 24px;
      font-family: AlibabaPuHuiTiB;
      color: #008AEA;
    }

    div:nth-of-type(2) {
      font-size: 18px;
      font-family: AlibabaPuHuiTiR;
      color: #303133;
      margin-top: 8px;
    }
  }

  .f11-container {
    width: 960px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    img {
      width: 142px;
      margin-bottom: 10px;

    }
  }

  .f11-title {
    font-size: 18px;
    font-family: AlibabaPuHuiTiM;
    color: #303133;
    font-weight: 700;
    margin-bottom: 15px;
  }

  .numberIcon {
    width: 960px;
    margin: 24px 0 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .icons {
      width: 140px;
      height: 80px;
      background: #FFFFFF;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      font-size: 14px;
      font-family: AlibabaPuHuiTiR;
      color: #303133;
      font-weight: 700;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;

      .top_ {
        width: 52px;
        position: absolute;
        top: 0;
        right: 0;
      }

      img {
        width: 40px;
      }
    }
  }

  .pageTitle {
    font-size: 40px;
    font-family: AlibabaPuHuiTiB;
    color: #303133;
    text-align: center;
    margin: 40px 0;
    font-weight: 700;
  }

  .pageTitle2 {
    width: 960px;
    padding-bottom: 16px;
    box-sizing: border-box;
    border-bottom: 1px #e6e6e6 solid;
    font-size: 18px;
    font-family: AlibabaPuHuiTiR;
    color: #303133;
    font-weight: 700;
  }
}
</style>
